import {
  Component,
  Input, Output,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
  OnDestroy,
  ElementRef,
  ViewChild,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';



//
// Store Interface
//
import { Store } from '@ngrx/store';


import { IAppCoreState } from '../../../state';
import { SubSink } from 'subsink';
import { SharedFunctionService } from '../../../services/shared-func.service';
import { SharedDataService } from '../../../services/shared-data.service';
import { getAppNavBar } from 'src/app/core/state/selectors';
import { AppNavBarOpenDialog } from 'src/app/core/state/actions/app-navbar.action';
import { WebSocketManagerService, SocketPayloadType } from '../../../services/websocket-manager.service';

import { Event, Router, NavigationStart, NavigationExtras, NavigationEnd } from '@angular/router';

import * as fromSelector from '../../../state/selectors/index';
import * as appNotificationsActions from '../../../state/actions/app-notification.action';
import { DealRoute } from 'src/app/shared/model/api';
import { AppNotification } from 'src/app/shared/model/api/AppNotification';
import { SocketPayload } from 'src/app/shared/model/api/SocketPayload';
import { AudioService } from 'src/app/core/services/audio.service';
import { ViewConstants } from 'src/app/constants';
import { CdkMessageService } from 'src/app/shared/model/common/sdk-message';
import { Library,Action } from 'src/assets/core';
import { ToastrService } from 'ngx-toastr';
import { ConAppToaster } from '../con-app-toaster/con-app-toaster';

@Component({
  selector: 'con-app-navbar',
  templateUrl: 'con-app-navbar.html',
  styleUrls: ['con-app-navbar.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConAppNavBar implements OnInit, OnDestroy {
  @Input('template') public toolbarTemplate: TemplateRef<any>;
  @Input() public disabled: boolean;
  @Input() public hidden: boolean;
  // public delearName: string = '';

  @Output() emitPathValue = new EventEmitter();
  @ViewChild('profileTemplate', {static: false}) profileTemplate: ElementRef;
  @ViewChild('messagesTemplate', {static: false}) messagesTemplate: ElementRef;
  @ViewChild('superMenuTemplate', {static: false}) superMenuTemplate: ElementRef;

  //
  // Public Variables
  //
  public model: any;
  public profileData: any = [];
  public navAction: Action;
  //
  // Subscriptions
  //
  private readonly subs = new SubSink();
  public modalDialog: any;
  public navBarPopUpClose: boolean;
  public currentScreen: string;
  public openunsaveWriteupsDialog: boolean;

  //
  // notification
  //
  public hasNotification = false;
  public newNotification = false;
  public newMessage = false;
  public interval: any;
  public messageInterval:any;
  //
  // is app online(socket connected) 
  //
  public isOnline = false;
  public hasComment:boolean = false;
  public dealerCode: string;
  public dealerName: string;

  private readonly toDate: any;
  private readonly fromDate: any;
  private count=0;
  private messagecount=0;
  public toggleProfileTemplateFlag: boolean = false;
  //public notifications : DealSummaryView = null;

  /**
   * constructor()
   */
  constructor(
    private readonly _store: Store<IAppCoreState>,
    public _sharedDataService: SharedDataService,
    public _sharedFuncService: SharedFunctionService,
    private readonly toastrService: ToastrService,
    private readonly audioService: AudioService,
    public router: Router,
    private readonly webSocketManager: WebSocketManagerService,
    private readonly _modalService: CdkMessageService,
    private readonly cdRef : ChangeDetectorRef
  ) {
    this.disabled = false;
    this.hidden = false;
    this.model = {};
  }

  public ngOnInit() {
    this._sharedDataService.profileTemplateToggleSubject.subscribe(flag => this.toggleProfileTemplateFlag = flag);
    //
    // Only if on summary screen, show super menu
    // Else show back
    //
    this.currentScreen = 'notsummary';
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (event.url === '/wl/summary')
          this.currentScreen = 'summary';
        else
          this.currentScreen = "notsummary";
      }
      if (event instanceof NavigationEnd) {
        if (event.url === '/wl/summary' || event.urlAfterRedirects  === '/wl/summary') {
          this.currentScreen = 'summary';
        }
        else {
          this.currentScreen = "notsummary";
        }
        if (event.url.indexOf('/cv') !== -1) {
          this.hidden = true;
        } else {
          this.hidden = false;
        }
      }
    });
    //
    // in case url of a feature module is directly typed in address bar, 
    // the above router event wont happen.
    // so the below code will only be executed once and take care of that situation
    // 
    if (this.router.url === '/wl/summary' || this.router.url === '/') {
      this.currentScreen = 'summary';
    }
    //
    // Get Menu Items
    //
    this.subs.sink =
      this._store.select(getAppNavBar).subscribe(state => {
        //
        // Set Active menu
        // 
        this.model = state;
        this.dealerCode = this._sharedDataService.dealerCode;

        if (this.model?.avatar?.name) {
          const profileInfo: any = this.model.avatar.name;
          this.profileData = profileInfo.toUpperCase();
          this._sharedDataService.managerName=this.profileData;
          this.model.avatar.onClick = () => {
            this._sharedDataService.profileTemplateToggleSubject.next(true);
            setTimeout(() => {
              if(document.getElementById("con-app-logout-div"))
              {
                document.getElementById("con-app-logout-div").focus();
              }
           }, 500);
          }
          this.model.notification.onClick = () => {
            this.count=0;
            this.newNotification = false; 
            clearInterval(this.interval);
            this._store.dispatch(appNotificationsActions.AppNotificationShowPanel());
          }
          this.model.menu.onClick = () => {
            const payload = {
              template: this.superMenuTemplate,
              data: {},
              style: {
                // right: '100px',
                top: '200px',
                left: '50%',
                width: '800px',
                height: '300px',
                'background-color': 'white',
                'border-radius': 'gray',
                'margin-left': 'auto',
                'margin-right': 'auto'
              }
            };
            this._store.dispatch(AppNavBarOpenDialog({payload}));
          }

        }
       
      });


    //
    // dispatch fetch notification action. wont issue an http call if not authorized
    //
    this._store.dispatch(appNotificationsActions.AppNotificationInitialFetch());

    //
    // has notification?. maybe better off to remove this state and figure it out with notifications
    //
    this.subs.sink = this._store.select(fromSelector.selectHasAppNotification).subscribe(hasNotification => {
      this.hasNotification = hasNotification;
    }
    );
    //
    // is app online ( is socket connected?)
    //
    this.subs.sink = this._store.select(fromSelector.selectAppOnlineStatus).subscribe(isOnline => {
      this.isOnline = isOnline;
    }
    );
    this.subs.sink = this._store.select(fromSelector.selectAppToasts).subscribe(toasts => {
      this.newNotification = true;
      clearInterval(this.interval);
      this.startBlink();
      toasts = toasts.filter( item => item.deal.onlineStatus != ViewConstants.ONLINE_STATUS_READY_FOR_DEALER)
      this.notificationToast(toasts)
    });

    //
    // connect the socket
    //
    this.webSocketManager.connect();
    //
    // listen to incoming notification
    //
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.Notification).subscribe(e => {
      let status= e.payload.deal.status;
      let showToast=false;
      this._sharedDataService.toastChatType=false;
      if(!e.payload.deal.salesPersonComments){
      if(e.payload.deal.reviewManager!=null && e.payload.deal.reviewManager.length>0 && e.payload.deal.reviewManager.filter(e => e.id.toString().toLowerCase() === this._sharedDataService.loggedInUserId.toString().toLowerCase()).length > 0)
      {
        showToast=true;
      }
      this._store.dispatch(appNotificationsActions.AppNotificationUpdate( {
        payload: {
          deal: {
            dealTransactionId: e.payload.deal.dealTransactionId,
            dealType: e.payload.deal.dealType,
            paymentType: e.payload.deal.paymentType,
            status: status,
            onlineStatus: this._sharedDataService.getOnlineStatus(e.payload.deal),
            updatedDate: e.payload.deal.updatedDate,
            salesPersonComments: (status === "Message"),
            salesPerson: status==="Message"?e.payload.deal.dealTermComment.commentGivenBy:e.payload.deal.salesPerson,
            dealTermComment: e.payload.deal.dealTermComment?e.payload.deal.dealTermComment:  {
                userRole: "",//"SALES_MANAGER"
                commentDate: "",//"2020-01-15 21:15:12"
                commentTXT: "",//"hai this is 2nd message to test chat"
                commentGivenBy: ""
              },
            // {
            //   userRole: "",//"SALES_MANAGER"
            //   commentDate: "",//"2020-01-15 21:15:12"
            //   commentTXT: "",//"hai this is 2nd message to test chat"
            //   commentGivenBy: ""
            // },
            writeupType: this.getWriteupType(e.payload),
            reviewManager: e.payload.deal.reviewManager,
            isToast:showToast
          },
          customer: {
            firstName: e?.payload?.customer?.firstName ? e.payload.customer.firstName:"",
            lastName: e?.payload?.customer?.lastName ? e.payload.customer.lastName:""
          },
          cobuyer: {
            firstName: e?.payload?.cobuyer?.firstName ? e.payload.cobuyer.firstName:'',
            lastName: e?.payload?.cobuyer?.lastName ? e.payload.cobuyer.lastName:''
          },
        }
      } ));
      this._store.dispatch(appNotificationsActions.AppNotificationClearToasterMessages());
    }else if(e.payload.deal.salesPersonComments){
      this.notificationToast([e.payload], true);
      this._store.dispatch(appNotificationsActions.AddChatComment({ payload: e.payload }));
      this.hasComment = true;
      this.newMessage =true;
      this.cdRef.detectChanges();  
      clearInterval(this.messageInterval);
      this.startMessageBlink();
    }

    });

    //
    // remove the notification if its viewed
    //
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.DealView).subscribe(e => {
      this._store.dispatch(appNotificationsActions.AppNotificationRemove({payload: e.payload.deal.dealTransactionId}));
    });

    //store chat comments

    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.Chat).subscribe(webSocketEvent => {
      this.notificationToast([webSocketEvent.payload], true);
      this._store.dispatch(appNotificationsActions.AddChatComment({ payload: webSocketEvent.payload }));
    });
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.ChatVisisted).subscribe(webSocketEvent => {
      let dealId;
      if (webSocketEvent.payload.type === 'DEAL_COMMENT_VISITED') {
        dealId = webSocketEvent.payload.deal.dealTransactionId
      }
      this.subs.sink = this._store.select(fromSelector.selectAppChatComments).subscribe(comments => {
        comments.forEach(c => {
          if (c.deal.dealTransactionId === dealId) {
            this._store.dispatch(appNotificationsActions.ClearChatComment({ payload: c}));
          }
        });
      });
    });
    this.subs.sink = this._store.select(fromSelector.selectAppChatComments).subscribe(comments => {
      if(!Library.isNullOrUndefined(this._sharedDataService.dealTransacId) && this._sharedDataService.dealTransacId.length >0){
        comments.forEach(c => {
          if (c.deal.dealTransactionId === this._sharedDataService.dealTransacId && this._sharedDataService.isNotesClicked)  {
            this._store.dispatch(appNotificationsActions.ClearChatComment({ payload: c }));
          }
        });
      }
      this.hasComment = comments.length > 0;
      this.newMessage =true;
      this.cdRef.detectChanges(); 
      clearInterval(this.messageInterval);
      this.startMessageBlink();
    });
  }

  private notificationToast(content, isComment?){
    const toastConfig = {
      toastComponent: ConAppToaster,
      payload: {},
      closeButton: true,
      timeOut: 10000
    }
    while (content.length > 0) {
      let toast = content.pop();
      if(isComment){
        if(toast.type === 'DEAL_UPDATE')
        toast.deal.salesPerson = toast.salesPerson
        else
        toast.deal.salesPerson = toast.deal.dealTermComment.commentGivenBy;
        toast.deal.writeupType = this.getWriteupType(toast);
        toast.deal.onlineStatus = this._sharedDataService.getOnlineStatus(toast.deal);
        toast.deal.status = 'Message';
        this._sharedDataService.toastChatType=true;
      }
      //
      // get additional parameters needed for writeup-details module
      //
      // let navExtra = this.getNavigationExtras(toast);
      if (!this.router.url.includes('wd/writeup-detail')) {
        const toastData = {};
        const salesPerson = toast.deal.salesPerson.toUpperCase();
        const customer = toast.customer;
        const cobuyer = toast.cobuyer;
        const vehicle = toast.deal?.vehicle ?? toast.vehicle;
        const writeupType = toast.deal.writeupType || '';
        const status = toast.deal.status || '';
        toastData['fullToastObject']=toast
        toastData['salesPerson'] = salesPerson;
        toastData['customerFullName'] = `${customer.firstName} ${customer.lastName} ${cobuyer && cobuyer.firstName != undefined ? cobuyer.firstName + ' ' + cobuyer.lastName : ''}`;
        toastData['writeupType'] = writeupType.toUpperCase();
        toastData['status'] = status;
        if(toast.deal.status=='Message'){
          toastData['vehicleInfo'] = `${vehicle?.modelYear || ''} ${vehicle?.brand || ''} ${vehicle?.modelMarketingName || ''}`.toUpperCase();
        }
        else{
          toastData['onlineStatus'] = toast.deal.onlineStatus
        }
        toastConfig.payload = toastData;
        if(!this._sharedDataService.isUserSalesConsultant){
          this.audioService.playNotificationRingtone();
          this.toastrService.show(null, null, toastConfig);
        }
      }
    }
  }
  startBlink(){
    
    this.interval=setInterval(()=>{
      this.count=this.count+1
      if(this.count>=8){
        this.count=0;
        this.newNotification = false; 
        clearInterval(this.interval);
        
       }   
    }, 1000)
  }
  startMessageBlink(){
    this.messageInterval=setInterval(()=>{
      this.messagecount=this.messagecount+1
      if(this.messagecount>=8){
        this.messagecount=0;
        this.newMessage = false; 
        this.cdRef.detectChanges(); 
        clearInterval(this.messageInterval);
       }   
    }, 1000)
  }
  get getCarType() {
    //later if we need any specific access control on lexus we can open for now we are setting acces control at dealer level so commented below code and returning tru every time
    return true;
  }

  private getWriteupType(msg: SocketPayload): string {
    if (msg.deal.paymentType == null && msg.deal.dealType == "TRADEIN")
      return "Trade";
    if (msg.deal.paymentType != null && ["TRADEIN", "TRADEIN&PAYMENT"].includes(msg.deal.dealType)) {
      switch (msg.deal.paymentType) {
        case "LEASE":
          return "Trade - Lease";
        case "FINANCE":
          return "Trade - Finance";
        case "CASH":
          return "Trade - Cash";
        case "APR":
          return "Trade - Finance";
      }
    }
    if (msg.deal.paymentType != null && (!(["TRADEIN", "TRADEIN&PAYMENT"].includes(msg.deal.dealType)))) {
      switch (msg.deal.paymentType) {
        case "LEASE":
          return "Lease";
        case "FINANCE":
          return "Finance";
        case "CASH":
          return "Cash";
        case "APR":
          return "Finance";
      }
    }
    //return returnValue;
  }
  //
  // return data required for navigating to writeup-details module
  //
  private getNavigationExtras(data: AppNotification) {

    let dealRoute: DealRoute = {};
    if (data.customer) {
      dealRoute.customer = data.customer.firstName + data.customer.lastName;
    }
    if (data.deal.paymentType) {
      dealRoute.dealType = data.deal.paymentType === 'APR' ? 'finance' : data.deal.paymentType.toLowerCase();
    }
    else {
      dealRoute.dealType = data.deal.dealType;
    }
    dealRoute.dealStatus = data.deal.status;
    dealRoute.dealTransactionId = data.deal.dealTransactionId;
    dealRoute.salesConsultant = data.deal.salesPerson;
    dealRoute.isNotification = true;
    dealRoute.timestamp = Date.now();
    let navigationExtras: NavigationExtras = {
      // queryParams: {
      //   "dealRoute": JSON.stringify(dealRoute)
      // },
      skipLocationChange: false,
      state: dealRoute
    };

    return navigationExtras;
  }


  ///-------------------------------------------------------------
  //
  // ngOnDestroy
  //
  public ngOnDestroy() {
    this.subs.unsubscribe();
  }

  public logout(event) {
    this._sharedFuncService.logout(window);
  }

  openSuperMenu(){
    this._sharedDataService.superMenuToggleSubject.next(true);
  }

  navigateToSummary(event, clickType) {
    if(!this._sharedDataService.iscalculateTriggered) {
      this._sharedDataService.setHideLoader(false);
      this.router.navigate(['/wl/summary']);
    } else {
      this.openunsaveWriteupsDialog = true;
      this._sharedDataService.isunsavedPopup = true;

      if(clickType === 'tab'){
      setTimeout(() => {
        if(document.getElementById("savedChanges-cancel"))
        {
          document.getElementById("savedChanges-cancel").focus();
        }
     }, 500);
    }
    }

    if(!this._sharedDataService.iscalculateTriggered) {
      if(this._sharedDataService.currentActiveTab === 'leads') {
        this._sharedDataService.summaryPageActiveTab.next('leads')
      } else if(this._sharedDataService.currentActiveTab === 'by customer') {
        this._sharedDataService.summaryPageActiveTab.next('by customer')
      } else {
        this._sharedDataService.summaryPageActiveTab.next('writeups')
      }
    }
  }

  ContinueUnsaved(event){
    if(event && event === 'ok'){
      this._sharedDataService.iscalculateTriggered = false;
      this.openunsaveWriteupsDialog = false;
      this._sharedDataService.isunsavedPopup = false;
      this._modalService.dispatch({ action: 'close' });
      this._sharedDataService.setHideLoader(false);
      this.router.navigate(['/wl/summary']);
    }
  }

  public hideProfileTemplate(){
    this._sharedDataService.profileTemplateToggleSubject.next(false);
  }
  closeSuccessModal(event) {
    if (event === 'close') {
      this.openunsaveWriteupsDialog = false;
      document.getElementById('backIcon').focus();
      this._sharedDataService.isunsavedPopup = false;
      this._modalService.dispatch({ action: 'close' });
    }
  }
  public chatpanelopen=false
  OpenChat($event) {
    this.chatpanelopen = $event
    clearInterval(this.messageInterval);
  }
}




